export async function applySortingToGroupItems({
                                                   url = '/portal/de/bundles/',
                                                   itemSelector = '.weekly__group--item',
                                                   root = document,
                                                   makeClickable = true,
                                               } = {}) {
    const base = new URL(url, location.origin);

    const res = await fetch(base, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Laden fehlgeschlagen: ${res.status}`);

    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

    const norm = s => s.replace(/[\s\u00A0]+/g, ' ').trim().toLowerCase();

    const map = new Map();
    for (const el of doc.querySelectorAll('.weekly__headline')) {
        const item = el.closest('.item');
        if (!item) continue;

        const sorting = item.dataset.sorting;
        const link = item.querySelector('a[href]');
        if (!sorting || !link) continue;

        // nur den Pfad aus dem Original-Link ziehen, Query selbst bauen
        const { pathname } = new URL(link.getAttribute('href'), base);

        map.set(norm(el.textContent), `${pathname}?sorting=${sorting}`);
    }

    let updated = 0;

    for (const item of root.querySelectorAll(itemSelector)) {
        const key = norm(item.getAttribute('title') || item.textContent);
        const href = map.get(key);
        if (!href) continue;

        item.setAttribute('href', href);
        if (makeClickable && !item.dataset.hrefBound) {
            item.dataset.hrefBound = '1';
            item.style.cursor = 'pointer';
            item.addEventListener('click', () => { location.href = href; });
        }
        updated++;
    }

    return updated;
}